export default "__VITE_PUBLIC_ASSET__6377ff66__"